export const fmtNumber = (v: number, digits = 1) => v.toLocaleString(undefined, { maximumFractionDigits: digits });
/** A date-only string ("2026-08-31") is a calendar day, not an instant: parse it in the
 *  viewer's own zone, or `new Date` reads it as UTC midnight and anyone west of UTC sees
 *  the day before. Anything with a time component is an instant and parses as usual. */
const parse = (iso: string) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(iso);
};
export const fmtDate = (iso: string | null | undefined) => (iso ? parse(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" }) : "—");
export const fmtDateTime = (iso: string | null | undefined) => (iso ? parse(iso).toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const relative = (iso: string | null | undefined) => {
  if (!iso) return "never";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 90) return "just now";
  if (s < 5400) return `${Math.round(s / 60)} min ago`;
  if (s < 129600) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};
export const title = (s: string) => s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
